<!--企业信息库-->
<template>
  <div class="info-base-container">
    <header-index/>
    <div class="info-base-content">
      <div class="info-base-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>{{ breadcrumbName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info-base-holder">
        <el-container>
          <el-aside width="180px" style="background: #ffffff;">
            <div class="info-base-nav-menu">
              <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="handleSelect"
                       background-color="#FFFFFF" active-text-color="#1637FF">
                <el-menu-item :index="vertical.href" v-for="vertical of navigationBar">
                  {{ vertical.name }}
                </el-menu-item>
              </el-menu>
            </div>
          </el-aside>
          <el-main>
            <listedCompany v-if="activeIndex=='/enterpriseSearch/listedCompany'"/>
            <financing v-if="activeIndex=='/enterpriseSearch/financing'"/>
            <investment-institutions v-if="activeIndex=='/enterpriseSearch/investmentInstitutions'"/>
            <industrial-chain v-if="activeIndex=='/enterpriseSearch/industrialChain'"/>
            <industrial-park v-if="activeIndex=='/enterpriseSearch/industrialPark'"/>
            <bond v-if="activeIndex=='/enterpriseSearch/bond'"/>
          </el-main>
        </el-container>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import cityJson from "@/static/cityJson.json";
import listedCompany from "@/views/enterpriseSearch/listedCompany";
import Financing from "@/views/enterpriseSearch/financing";
import InvestmentInstitutions from "@/views/enterpriseSearch/investmentInstitutions";
import IndustrialChain from "@/views/enterpriseSearch/industrialChain";
import IndustrialPark from "@/views/enterpriseSearch/industrialPark";
import Bond from "@/views/enterpriseSearch/bond";

export default {
  name: "infoBase",
  components: {
    Bond,
    IndustrialPark,
    IndustrialChain,
    InvestmentInstitutions,
    Financing,
    headerIndex,
    home_footer,
    Hang,
    listedCompany
  },
  data() {
    return {
      cid: 0,
      cityList: {},
      breadcrumbName: '',
      activeIndex: '/enterpriseSearch/listedCompany',
      navigationBar: [
        {name: '上市公司', index: 1, href: '/enterpriseSearch/listedCompany'},
        {name: '融资事件', index: 2, href: '/enterpriseSearch/financing'},
        {name: '投资机构', index: 3, href: '/enterpriseSearch/investmentInstitutions'},
        {name: '产业链', index: 4, href: '/enterpriseSearch/industrialChain'},
        {name: '产业园区', index: 5, href: '/enterpriseSearch/industrialPark'},
        {name: '债券', index: 5, href: '/enterpriseSearch/bond'},
      ]
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      localStorage.setItem('infoBase', key);
    }
  },
  beforeMount() {
    this.breadcrumbName = this.$route.query.name;
    if (this.breadcrumbName == '上市企业') {
      this.activeIndex = '/enterpriseSearch/listedCompany';
      localStorage.setItem('infoBase', '/enterpriseSearch/listedCompany');
    } else if (this.breadcrumbName == '融资事件') {
      this.activeIndex = '/enterpriseSearch/financing';
      localStorage.setItem('infoBase', '/enterpriseSearch/financing');
    } else if (this.breadcrumbName == '投资机构') {
      this.activeIndex = '/enterpriseSearch/investmentInstitutions';
      localStorage.setItem('infoBase', '/enterpriseSearch/investmentInstitutions');
    } else if (this.breadcrumbName == '产业链') {
      this.activeIndex = '/enterpriseSearch/industrialChain';
      localStorage.setItem('infoBase', '/enterpriseSearch/industrialChain');
    } else if (this.breadcrumbName == '产业园区') {
      this.activeIndex = '/enterpriseSearch/industrialPark';
      localStorage.setItem('infoBase', '/enterpriseSearch/industrialPark');
    } else if (this.breadcrumbName == '债券') {
      this.activeIndex = '/enterpriseSearch/bond';
      localStorage.setItem('infoBase', '/enterpriseSearch/bond');
    }
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__inner a,
.info-base-container >>> .info-base-content .info-base-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.info-base-container >>> .info-base-content .info-base-holder .info-base-nav-menu .el-menu-item.is-active {
  color: rgb(22, 55, 255);
  background: #DDE2FF !important;
}
.info-base-container >>> .info-base-content .info-base-holder .el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #333333;
  padding: 0 30px !important;
  border-bottom: 1px solid #E7E9F5;
  font-family: 'SourceHanSansCN';
}
.info-base-container >>> .info-base-content .info-base-holder .info-base-nav-menu .el-card__body, .el-main {
  padding: 0px 0px 0px 0px;
  margin-left: 20px;
  background: #FFFFFF;
}
</style>
<style scoped lang="scss">
.info-base-container {
  background: #F5F5F5;
  .info-base-content {
    padding: 10px 18%;
    background: #F5F5F5;
    min-width: 76rem;
    .info-base-holder {
      padding-top: 10px;
    }
  }
}
</style>